import { Client, User } from "@readai/common/types";
import type { AddReadUILocation } from "@readai/common/types/trackingTypes";

import { sendEvent } from "./Tracker";

export const deleteAccount = sendEvent<{
  userId: User["id"];
  reason: string;
  comments: string;
}>("delete_account");

export const pageNotFound = sendEvent<{ attempted_url: string }>(
  "page_not_found",
);

export const addReadToLiveMeeting = sendEvent<{
  uiLocation: AddReadUILocation;
}>("add_read_to_live_meeting");

export const exiCopilotSearch = sendEvent<{
  client: Client;
  query: string;
}>("exi_copilot_search");
